import { CommonModule } from '@angular/common';
import { Component, OnDestroy, signal } from '@angular/core';
import { NavigationEnd, RouterModule } from '@angular/router';
import { DeviceDetectService, EreaderControllerService, NavDataService, RolesService } from '@app/core/services';
import { AuthSessionService } from '@app/core/services/auth-session/auth-session.service';
import { ModalManagerService, ModalTypes } from '@app/core/services/modal-manager';
import { CurrencySelectComponent, LanguageSelectComponent } from '@app/shared';
import { ImageSrcsetComponent } from '@app/shared/components/image-srcset/image-srcset.component';
import { environment } from '@env/environment';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { UserService } from '@makiwin/ngx-drupal8-rest';
import { NgbDropdown, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { IkoIwoSelectorComponent } from './iko-iwo-selector/iko-iwo-selector.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    LanguageSelectComponent,
    LocalizeRouterModule,
    RouterModule,
    CurrencySelectComponent,
    NgbModule,
    TranslateModule,
    ImageSrcsetComponent,
    IkoIwoSelectorComponent,
  ],
})
export class HeaderComponent implements OnDestroy {
  currencies: Array<string> = ['USD', 'EUR'];
  selectedCurrency = 'USD';
  view = null;
  urlIsContent = false;
  isTablet = this.deviceDetectService.isTablet;

  /**
   * A reactive signal indicating whether the user is currently logged in.
   *
   * @readonly
   * @protected
   * @type {Signal<boolean>}
   * @see {@link AuthSessionService.isLogged}
   */
  protected readonly isLogged = signal<boolean>(this.authSessionService.isLogged);
  private readonly unsubscribeAll: Subject<void> = new Subject<void>();

  constructor(
    public navDataService: NavDataService,
    public deviceDetectService: DeviceDetectService,
    public ereaderControllerService: EreaderControllerService,
    public rolesService: RolesService,
    public userService: UserService,
    protected modalManagerService: ModalManagerService,
    protected authSessionService: AuthSessionService
  ) {
    this.authSessionService.currentUserProfile$
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe(() => this.isLogged.set(this.authSessionService.isLogged));
    this.navDataService.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this.urlIsContent = !(
          event.url.indexOf('/elearning/gallery') === -1 || event.url.indexOf('/gallery/skills') !== -1
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  protected openCourses() {
    this.navDataService.navigate('/gutenberg/296');
  }

  protected openSpecialAdvisories() {
    this.navDataService.navigate(
      `https://${environment.serverUrl}/special-advisories?return_url=https://${environment.betaUrl}/sanction`,
      true
    );
  }

  protected handleDropDownMenu(menu: NgbDropdown) {
    if (!this.isTablet) {
      return;
    }
    menu.toggle();
  }

  protected handleMouseEnter(menu: NgbDropdown) {
    if (this.isTablet) {
      return;
    }
    menu.open();
  }
  protected handleMouseLeave(menu: NgbDropdown) {
    if (this.isTablet) {
      return;
    }
    menu.close();
  }

  /**
   * Open the modal membership plans base by product id.
   *
   * @param productId
   * Product id for the memberhsip plans
   */
  protected openModalMembership(productId: string) {
    this.modalManagerService.open(ModalTypes.subscriptions, { productId }).subscribe();
  }
}
